<template>
    <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 20.9785C15.5228 20.9785 20 16.5014 20 10.9785C20 5.45567 15.5228 0.978516 10 0.978516C4.47715 0.978516 0 5.45567 0 10.9785C0 16.5014 4.47715 20.9785 10 20.9785Z"
            fill="#F9F9F9"
        />
        <path
            d="M20.0003 10.9786C20.0003 6.67895 17.2865 3.01352 13.4785 1.60059V20.3566C17.2865 18.9437 20.0003 15.2782 20.0003 10.9786Z"
            fill="#E92B2B"
        />
        <path
            d="M0 10.9786C0 15.2782 2.71379 18.9437 6.52176 20.3566V1.60059C2.71379 3.01352 0 6.67895 0 10.9786Z"
            fill="#32AB45"
        />
    </svg>
</template>